import { AxiosInstance } from "axios";
import {
  IFilterSchema,
  IListQueryStringSchema,
  ISortSchema,
} from "../../Schemas/ListQueryString";
import { IResponseBody } from "../../Schemas/EndPoint";
import { AccessTokenSchema } from "../../Schemas/AccessToken";

interface Filter extends IFilterSchema {
  column: AccessTokenListColumnFilterable;
}

interface Sort extends ISortSchema {
  column: AccessTokenListColumnSortable;
}

export enum AccessTokenListColumnFilterable {
  ID = "id",
  WORKSPACE_ID = "workspace_id",
  PARTNER_ID = "partner_id",
  EXPIRED_AT = "expired_at",
  CREATED_AT = "created_at",
}
export enum AccessTokenListColumnSortable {
  ID = "id",
  WORKSPACE_ID = "workspace_id",
  PARTNER_ID = "partner_id",
  EXPIRED_AT = "expired_at",
  CREATED_AT = "created_at",
}

export interface ICreateAccessTokenPayload {
  workspace_id?: null | number;
  pbx_server_id: null |number;
  expired_at?: null | string;
}

export interface AccessTokenListQueryString extends IListQueryStringSchema {
  filters?: Filter[];
  sorts?: Sort[];
}

export interface AccessTokenListResponseBody extends IResponseBody {
  data: {
    access_tokens: AccessTokenSchema[];
    total: number;
  };
}
export interface AccessTokenCreateResponseBody extends IResponseBody {
  data: {
    access_token: string;
  };
}
export interface AccessTokenCreateResponseBodyShowToken extends IResponseBody {
  data: {
    secret:string
  };
}

export class AccessTokensListRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath() {
    return `/admin/access-tokens`;
  }

  async list(
    queryStrings?: AccessTokenListQueryString
  ): Promise<AccessTokenListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(this.getPath(), {
        params: queryStrings,
      });
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }

  async showToken(fieldId: string): Promise<AccessTokenCreateResponseBodyShowToken> {
    try {
      const { data } = await this.protectedAxiosInstance.get(
        this.getPath() + `/${fieldId}/show-token`
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }

  async create(
    payload: ICreateAccessTokenPayload
  ): Promise<AccessTokenCreateResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath() + `/create`,
        payload
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }

  async update(
    roleId: string,
    payload: Partial<ICreateAccessTokenPayload>
  ): Promise<AccessTokenCreateResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath() + `/${roleId}/update`,
        payload
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }

  async remove(roleId: string): Promise<AccessTokenCreateResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath() + `/${roleId}/delete`
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
